import { render, staticRenderFns } from "./PaymentFileDetails.vue?vue&type=template&id=5d0dbce5&scoped=true&"
import script from "./PaymentFileDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFileDetails.vue?vue&type=style&index=0&id=5d0dbce5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0dbce5",
  null
  
)

export default component.exports